import React, { useState, useEffect, useContext } from "react";
// import { DataTable } from "primereact/datatable";
// import Loading from "../../components/Loading";
import Loading from "../components/Loading.jsx";
import DataTable from "react-data-table-component";
import { FaEdit, FaTrash, FaEye, FaCalendarAlt, FaBars, FaBorderAll } from "react-icons/fa";
import { useUserContext } from '../context/DealerProfile.jsx'
import { TfiMenuAlt } from "react-icons/tfi";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import useSWR from "swr";
import { AllStates } from "../context/globalState.jsx";
// import { Pagination } from "flowbite-react";
// Paste this once in your component file or extract to its own file

const SimplePagination = ({ currentPage, totalPages, onPageChange }) => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
    }

    return (
        <div className="flex flex-wrap justify-center items-center gap-2 mt-4">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Previous
            </button>

            {/* {pages.map((page) => (
                <button
                    key={page}
                    onClick={() => onPageChange(page)}
                    className={`px-3 py-1 rounded ${page === currentPage
                            ? "bg-blue-500 text-white"
                            : "bg-gray-200 hover:bg-gray-300"
                        }`}
                >
                    {page}
                </button>
            ))} */}

            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Next
            </button>
        </div>
    );
};





export default function LeadsTable() {
    const { dealerDetail, error } = useUserContext();
    const { allState, allStatedispatch } = useContext(AllStates);
    // const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    // const [isLoading, setIsLoading] = useState(true);
    // const [leads, setLeads] = useState([]);
    // ✅ Current page state
    const [currentPage, setCurrentPage] = useState(() => {
        return Number(localStorage.getItem("currentPagePayments")) || 1;
    });
    // ✅ Rows per page state
    const [rowsPerPage, setRowsPerPage] = useState(() => {
        return Number(localStorage.getItem("rowsPerPagepayments")) || 25;
    });



    // ✅ Keep localStorage in sync with rowsPerPage
    useEffect(() => {
        localStorage.setItem("rowsPerPagepayments", rowsPerPage);
    }, [rowsPerPage]);

    // ✅ Keep localStorage in sync with currentPage
    useEffect(() => {
        localStorage.setItem("currentPagePayments", currentPage);
    }, [currentPage]);

    // ✅ Handle rows per page change
    const handleChange = (e) => {
        const value = Number(e.target.value);
        setRowsPerPage(value);

        setSearchValues((prev) => ({
            ...prev,
            limit: value,
            page: 1, // reset page
        }));

        setCurrentPage(1); // reset local state too
    };

    // ✅ Handle page change (from pagination component)
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);

        setSearchValues((prev) => ({
            ...prev,
            page: newPage,
        }));
    };

    const [openDropdown, setOpenDropdown] = useState(null);  // Track open dropdown
    const [formData, setFormData] = useState({}); // Store lead form data
    const [editingId, setEditingId] = useState(null);
    const [tasks, setTasks] = useState([]);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const [searchValues, setSearchValues] = useState({
        page: 1,
        limit: 25,
        dealerEmail: dealerDetail?.Email || "",
    });

    // Open modal
    // Open modal and save current state before changes
    const openModal = () => {
        setPrevSelectedColumns(selectedColumns); // Save current state before changes
        setIsModalOpen(true);
    };

    const columns = [
        {
            name: "Zoho Payments Id",
            selector: row => row.Name ?? "",
            cell: row => (
                <span
                    style={{
                        fontSize: 16,
                        cursor: "pointer",
                        color: "#5A5A5C",
                        transition: "color 0.2s ease-in-out",
                    }}
                    onMouseEnter={e => (e.target.style.color = "blue")}
                    onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
                    onClick={() => navigate(`/payment-details/${row.id}`)}
                >
                    {row?.Name}
                </span>
            ),
            sortable: true,
            wrap: true,
            style: { fontSize: 16, color: "#5A5A5C" },
            minWidth: "200px",
        },
        {
            name: "Email",
            selector: row => row.Email ?? "",
            sortable: true,
            style: { fontSize: 16, color: "#5A5A5C" },
            minWidth: "250px",
        },
        {
            name: "Payments Amount",
            selector: row =>
                typeof row.Amount === "number" ? row.Amount : parseFloat(row.Amount) || 0,
            cell: row => (
                <span
                    style={{
                        fontSize: 16,
                        cursor: "pointer",
                        color: "#5A5A5C",
                        transition: "color 0.2s ease-in-out",
                    }}
                    onMouseEnter={e => (e.target.style.color = "blue")}
                    onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
                    onClick={() => navigate(`/payment-details/${row.id}`)}
                >
                    {row.Amount}
                </span>
            ),
            sortable: true,
            wrap: true,
            style: { fontSize: 16, color: "#5A5A5C" },
            minWidth: "200px",
        },
        {
    name: "Payment Status",
    sortable: true,
    minWidth: "250px",
    cell: (row) => {
        const status = row.Order_Status ?? "Not Available";

        return (
            <span
                className={`px-4 py-1 rounded-full text-sm font-medium ${
                    status.toLowerCase() === "success"
                        ? "bg-green-500 text-white"
                        : status.toLowerCase() === "failure"
                        ? "bg-red-500 text-white"
                        : "bg-gray-500 text-white"
                }`}
            >
                {status}
            </span>
        );
    },
},
        {
            name: "Transaction Date",
            selector: row => {
                if (!row.Transaction_Date) return 0;
                return new Date(row.Transaction_Date).getTime(); // ✅ numeric timestamp for sorting
            },
            cell: row => (
                <span style={{ fontSize: 16, color: "#5A5A5C" }}>
                    {row.Transaction_Date
                        ? new Date(row.Transaction_Date).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                        })
                        : "—"}
                </span>
            ),
            sortable: true,
            wrap: true,
            style: { fontSize: 16, color: "#5A5A5C" },
            minWidth: "180px",
        },

        {
            name: "Donor Name",
            selector: row => {
                if (row.Donor_Type === "Acquisition") {
                    return row.Potential_Donor ?? "";
                }
                return row.Tagged_Donor ?? "";
            },
            cell: row => {
                const donorName =
                    row.Donor_Type === "Acquisition"
                        ? row.Potential_Donor
                        : row.Tagged_Donor;

                return (
                    <span style={{ fontSize: 16, color: "#5A5A5C" }}>
                        {donorName || "—"}
                    </span>
                );
            },
            sortable: true,
            wrap: true,
            style: { fontSize: 16, color: "#5A5A5C" },
            minWidth: "220px",
        }
        ,
        {
            name: "Payments Source",
            selector: row => row.Source ?? "",
            cell: row => (
                <span
                    style={{
                        fontSize: 16,
                        cursor: "pointer",
                        color: "#5A5A5C",
                        transition: "color 0.2s ease-in-out",
                    }}
                    onMouseEnter={e => (e.target.style.color = "blue")}
                    onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
                    onClick={() => navigate(`/payment-details/${row.id}`)}
                >
                    {row.Source}
                </span>
            ),
            sortable: true,
            wrap: true,
            style: { fontSize: 16, color: "#5A5A5C" },
            minWidth: "200px",
        },
         
    ];




    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [selectedColumns, setSelectedColumns] = useState(columns.map(col => col.name)); // Default: Show all columns
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedColumns, setSelectedColumns] = useState([]);


    // State to track the most recently clicked column
    const [lastClickedColumn, setLastClickedColumn] = useState(null);
    const [initialColumns, setInitialColumns] = useState([]); // Track initial columns state


    // Fetch columns from localStorage or default columns when component mounts
    useEffect(() => {
        const storedColumns = localStorage.getItem("selectedColumns");

        if (storedColumns) {
            // If columns are found in localStorage, use them
            const parsedColumns = JSON.parse(storedColumns);
            setSelectedColumns(parsedColumns);
            setInitialColumns(parsedColumns); // Save the initial state
        } else {
            // Otherwise, use default columns (this is assuming 'columns' is your default set)
            const defaultColumns = columns.map(col => col.name);
            setSelectedColumns(defaultColumns);
            setInitialColumns(defaultColumns); // Save the initial state
        }
    }, []);

    // Function to handle column changes
    const handleColumnChange = (colName) => {
        setSelectedColumns((prev) => {
            const updatedColumns = prev.includes(colName)
                ? prev.filter((name) => name !== colName)
                : [...prev, colName];

            try {
                // Ensure only primitive values (strings) are stored
                const safeColumns = updatedColumns.map(col => String(col));
                localStorage.setItem("selectedColumns", JSON.stringify(safeColumns));
            } catch (error) {
                // console.error("Error saving to localStorage:", error);
            }

            // Track the most recent checkbox clicked
            setLastClickedColumn(colName);

            return updatedColumns;
        });
    };


    // Function to apply filters (save to localStorage)
    const applyFilter = () => {
        try {
            // Ensure only primitive values (strings) are stored
            const safeColumns = selectedColumns.map(col => String(col));
            localStorage.setItem("selectedColumns", JSON.stringify(safeColumns));
        } catch (error) {
            // console.error("Error saving to localStorage:", error);
        }

        setIsModalOpen(false);
    };

    const [prevSelectedColumns, setPrevSelectedColumns] = useState([]); // Store previous state



    // Function to reset filter by restoring the saved state
    const resetFilter = () => {
        setSelectedColumns(prevSelectedColumns); // Restore previous selection
        setIsModalOpen(false);
    };


    const filteredColumns = columns.filter(
        col => selectedColumns.includes(col.name) || typeof col.name === "object"
    );

    // const [totalRecords, setTotalRecords] = useState(0);





    // const [isFetched, setIsFetched] = useState(false);

    // useEffect(() => {
    //     const fetchLeadValues = async () => {
    //         setIsLoading(true); // Start loading
    //         try {
    //             const response = await fetch(
    //                 "/server/dealer_backend/getAllPayments",
    //                 {
    //                     method: "POST",
    //                     headers: {
    //                         "Content-Type": "application/json",
    //                     },
    //                     body: JSON.stringify({
    //                         dealerEmail: dealerDetail?.Email,
    //                     }),
    //                 }
    //             );

    //             const data = await response.json();


    //             if (data.status === "success") {
    //                 // ✅ Filter leads that match dealer's email
    //                 const filteredLeads = data.data.filter(
    //                     (item) => item.Catalyst_User_Email === dealerDetail?.Email
    //                 );

    //                 //   console.log(filteredLeads)
    //                 setLeads(data.data);
    //             } else {
    //                 console.error("Failed to fetch payments:", data.error);
    //                 setLeads([]); // Ensure leads is set even on error
    //             }
    //         } catch (error) {
    //             console.error("Error fetching payments:", error);
    //             setLeads([]); // Avoid leads being undefined
    //         } finally {
    //             setIsLoading(false); // End loading
    //             setIsFetched(true);  // Mark fetch as complete
    //         }
    //     };


    //     fetchLeadValues();

    // }, []);
    // 1. Fetch and set contacts
    // const fetchContacts = async () => {
    //     setIsLoading(true);

    //     const key = `payments-${searchValues.page}-${searchValues.limit}-${dealerDetail?.Email}`;

    //     if (allState[key]) {
    //         setLeads(allState[key]?.data);
    //         setTotalRecords(allState[key]?.total);
    //         setIsLoading(false);
    //         return;
    //     }

    //     try {
    //         const res = await fetch("/server/dealer_backend/getAllPayments", {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({
    //                 page: searchValues.page,
    //                 limit: searchValues.limit,
    //                 dealerEmail: dealerDetail?.Email,
    //             }),
    //         });

    //         const data = await res.json();
    //         if (data.status === "success") {
    //             let allLeads = (data.data || []).sort(
    //                 (a, b) => new Date(b.Created_Time) - new Date(a.Created_Time)
    //             );
    //             allStatedispatch({
    //                 type: "add",
    //                 payload: { [key]: { data: allLeads, total: data.pagination.totalRecords } }
    //             });
    //             setLeads(allLeads);
    //             setTotalRecords(data.pagination.totalRecords);
    //         } else {
    //             setLeads([]);
    //         }
    //     } catch (error) {
    //         console.error("Error fetching payments:", error);
    //         setLeads([]);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };






    // useEffect(() => {
    //     fetchContacts();
    // }, [searchValues.page, searchValues.limit, dealerDetail?.Email]);


    const fetcher = async (url, body) => {
        const res = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
        });
        if (!res.ok) throw new Error("Failed to fetch payments");
        return res.json();
    };

    const { page, limit } = searchValues;

    // Build unique cache key for SWR
    const key = dealerDetail?.Email
        ? ["/server/dealer_backend/getAllPayments", {
            page,
            limit,
            dealerEmail: dealerDetail.Email,
            listName: dealerDetail?.List_Name
        }]
        : null; // prevent fetch if no dealer email

    const { data, isLoading } = useSWR(key, ([url, body]) => fetcher(url, body), {
        revalidateOnFocus: false, // optional: don’t refetch on tab focus
        keepPreviousData: true,  // optional: keep showing old page while loading new one
    });

    const leads = (data?.status === "success" ? data.data : [])?.sort(
        (a, b) => new Date(b.Created_Time) - new Date(a.Created_Time)
    );

    const pagination = data?.pagination || { page: 1, limit: 25, totalRecords: 0, totalPages: 1 };
    const totalPages = pagination.totalPages;
    const totalRecords = pagination.totalRecords;


    const onPageChange = (newPage) => {
        setCurrentPage(newPage);
        setSearchValues((prev) => ({
            ...prev,
            page: newPage
        }));
    };
    // const handleRowsPerPageChange = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setCurrentPage(1);
    // };



    const handleView = (rowData, field) => {

        navigate(`/owner-details/${rowData.id}`);

    };



    const handleEditClick = async (rowData) => {
        // setFormData(rowData); // Populate form with existing data before editing
        // setEditingId(rowData.id); // Store the ID of the lead being edited
        navigate(`/lead-edit/${rowData.id}`);
    };






    function useIsMobile(breakpoint = 768) {
        const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

        useEffect(() => {
            const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, [breakpoint]);

        return isMobile;
    }



    function MobileDonorCard({ donor }) {
        return (
            <Link to={`/payment-details/${donor.id}`}>
                <div className="bg-white shadow-md rounded-xl p-4 mb-4 w-[24%] hover:bg-gray-50 transition cursor-pointer">
                    <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-lg">
                                {`${donor.Name ?? ''}`.trim().charAt(0) || ''}

                            </div>
                            <div>
                                <p className="font-semibold text-gray-900"> {`${donor.Name || ''}`.trim()}</p>
                                <p className="text-xs text-gray-500">{donor.id}</p>
                            </div>
                        </div>
                        {/* <span className="text-xs bg-green-100 text-green-700 px-3 py-1 rounded-full font-semibold">
                            {donor.Order_Status || ''}
                        </span> */}
                    </div>

                    <hr className="my-2" />

                    <div className="text-sm text-gray-700">
                        <div className="flex justify-between mb-1">
                            <span className="text-gray-500">Email</span>
                            <span>{donor.Email || 'N/A'}</span>
                        </div>
                        {/* <div className="flex justify-between">
                                <span className="text-gray-500">Zoho Payments Id</span>
                                <span>{donor.Name || 'N/A'}</span>
                            </div> */}
                        {/* <div className="flex justify-between">
                            <span className="text-gray-500">Modified Time</span>
                            <span>{new Date(donor.Modified_Time).toLocaleString() || ''}</span>
                        </div> */}
                    </div>
                </div>
            </Link>
        );
    }




    const isMobile = useIsMobile();






    return (
        <div>

            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-[300px]" onClick={(e) => e.stopPropagation()}>
                        <h2 className="text-xl font-bold mb-4">Manage Columns</h2>

                        {/* Search Box */}
                        <input
                            type="text"
                            placeholder="Search"
                            className="w-full p-2 border rounded mb-2"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />

                        {/* Column Selection */}
                        {/* Column Selection */}
                        <div className="max-h-60 overflow-auto">
                            {columns
                                .filter(col => typeof col.name === "string")
                                .filter(col => col.name.toLowerCase().includes(searchTerm.toLowerCase()))
                                .map((col, index) => {
                                    const isLastName = col.name === "Last Name";
                                    return (
                                        <label key={index} className="flex items-center mb-2">
                                            <input
                                                type="checkbox"
                                                checked={selectedColumns.includes(col.name)}
                                                onChange={() => {
                                                    if (!isLastName) {
                                                        handleColumnChange(col.name);
                                                    }
                                                }}
                                                disabled={isLastName} // Prevent deselection
                                                className="mr-2"
                                            />
                                            {col.name}
                                        </label>
                                    );
                                })}
                        </div>



                        {/* Buttons */}
                        <div className="flex justify-end mt-4 gap-2">
                            <button className="px-4 py-2 bg-red-500 text-white rounded" onClick={resetFilter}>Cancel</button>
                            <button className="px-4 py-2 bg-blue-500 text-white rounded" onClick={applyFilter}>Save</button>
                        </div>
                    </div>
                </div>
            )}


            <h2 className="table-title"></h2>
            <div className="payments-content ">
                {/* <h2 className="mr-[52.2rem] mt-[10px] font-bold text-xl">Leads</h2> */}
                <div className="table-header flex justify-between items-center p-4">



                    {/* FaBars icon button */}
                    {/* <div className="manage-columns relative group inline-block flex hidden md:flex">
                        <div
                            className="p-2 bg-white rounded-md shadow cursor-pointer hover:text-blue-500 transition mt-[12px] mr-[12px]"
                            onClick={openModal}
                        >
                            <TfiMenuAlt className="text-xl text-blue-500" />
                        </div>

                        <div className="absolute left-1/2 -translate-x-1/2 top-full mt-2 bg-gray-800 text-white text-sm px-2 py-1 rounded shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-10">
                            Manage Columns
                        </div>
                    </div> */}




                    {/* Add Lead button */}
                    {/* <button
                        onClick={() => navigate("/create-lead")}
                        className="create-button bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md transition"
                    >
                        Add Lead
                    </button> */}
                </div>





                {/* Show Loading */}
                {isLoading ? (
                    <div className="loading-circle flex justify-center items-center gap-2 py-6 text-blue-500">
                        <svg
                            className="animate-spin h-5 w-5 text-blue-500"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            ></circle>
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                            ></path>
                        </svg>
                        <span>Loading Data...</span>
                    </div>

                ) : leads.length === 0 ? (
                    <div className="text-center py-6 text-blue-500">No data available</div>
                ) : (
                    isMobile ? (
                        <div className="px-4">
                            {leads.map((donor, index) => (
                                <MobileDonorCard key={index} donor={donor} />
                            ))}
                        </div>
                    ) : (
                        <>
                            <div className="w-[70rem] overflow-auto">
                                <DataTable
                                    columns={columns}
                                    data={leads}
                                    fixedHeader
                                    dense
                                    responsive
                                    highlightOnHover
                                    progressPending={isLoading}
                                    className="custom-table text-base"
                                    onRowClicked={(row) => navigate(`/payment-details/${row.id}`)}
                                    customStyles={{
                                        headCells: { style: { fontSize: "16px", fontWeight: "700", background: "#F3F7FA", color: "#1e3a8a" } },
                                        cells: { style: { whiteSpace: "nowrap", overflow: "visible", fontSize: "15px" } },
                                        rows: {
                                            style: {
                                                transition: "background 0.2s",
                                                "&:hover": { background: "#ebf4ff" },
                                            },
                                        },
                                    }}
                                    style={FaBorderAll}
                                />
                            </div>


                            {/* Show Pagination only when leads are loaded */}
                            <div className="mr-8 table-footer mt-5 flex flex-wrap justify-between items-center gap-4">

                                {/* Showing X–Y of Z */}
                                <div className="flex items-center text-gray-700 text-sm md:text-base">
                                    <span className="font-medium mr-1">Showing</span>
                                    <span className="px-2 py-1 bg-blue-100 text-blue-700 font-semibold rounded-lg">
                                        {`${(currentPage - 1) * rowsPerPage + 1}–${Math.min(
                                            currentPage * rowsPerPage,
                                            totalRecords
                                        )}`}
                                    </span>
                                    <span className="ml-1">of {totalRecords} entries</span>
                                </div>

                                {/* Rows per page dropdown */}
                                <div className="flex items-center gap-2">
                                    <label
                                        htmlFor="rowsPerPage"
                                        className="text-gray-700 font-medium select-none"
                                    >
                                        Records per page
                                    </label>
                                    <select
                                        id="rowsPerPage"
                                        value={rowsPerPage}
                                        onChange={handleChange}
                                        className="border border-gray-300 rounded-lg px-3 py-1.5 shadow-sm bg-white 
        focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                                    >
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={250}>250</option>
                                    </select>
                                </div>

                                {/* Pagination */}
                                <SimplePagination
                                    currentPage={currentPage}
                                    totalPages={Math.ceil(totalRecords / rowsPerPage)}
                                    onPageChange={handlePageChange}
                                />
                            </div>




                        </>
                    )
                )}

            </div>




        </div>
    );
}
